import type { FC } from 'react';

import { type IBaseButtonProps } from './BaseButton'
import { TertiaryButtonStyled } from './styles/TertiaryButtonStyled'

export const TertiaryButton: FC<IBaseButtonProps> = TertiaryButtonStyled

TertiaryButton.displayName = 'TertiaryButton'
